"use strict";
/* tslint:disable variable-name */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var identifiers_1 = require("../identifiers");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var Calendar_1 = require("./Calendar");
var theme = require("./theme.scss");
function mapCalendarThemeToClassNames(_theme) {
    return {
        calendar: _theme.calendar,
        dateRange: _theme.dateRange,
        predefinedRanges: _theme.predefinedRanges,
        predefinedRangesItem: _theme.predefinedRangesItem,
        predefinedRangesItemActive: _theme.predefinedRangesItemActive,
        monthAndYear: _theme.monthAndYear,
        weekDays: _theme.weekDays,
        weekDay: _theme.weekDay,
        days: _theme.days,
        day: _theme.day,
        dayToday: _theme.dayToday,
        dayActive: _theme.dayActive,
        dayPassive: _theme.dayPassive,
        dayInRange: _theme.dayInRange,
        monthAndYearWrapper: _theme.monthAndYearWrapper,
        prevButton: _theme.prevButton,
        nextButton: _theme.nextButton,
        month: _theme.month,
        monthAndYearDivider: _theme.monthAndYearDivider,
        year: _theme.year,
        daySunday: _theme.daySunday,
        daySpecialDay: _theme.daySpecialDay,
        enabledPassiveDay: _theme.enabledDayPassive,
    };
}
var mapThemrProps = function (props, _theme) {
    return tslib_1.__assign({}, props, { theme: _theme, calendarClassNames: mapCalendarThemeToClassNames(_theme) });
};
var ThemedCalendar = react_css_themr_1.themr(identifiers_1.CALENDAR, theme, { mapThemrProps: mapThemrProps })(Calendar_1.default);
exports.Calendar = ThemedCalendar;
exports.default = ThemedCalendar;
